import { deleteOrder, deleteOrders, downloadOrder, fetchOrders, createOrder } from 'api';
import useAxios from 'hooks/useAxios';
import { IBulkDeleteRequest, IOrderResource, IOrderPostRequest } from '../../server/types';

const useFetchOrders = () => {
  const [request, { loading, error }] = useAxios<IOrderResource[]>();

  const handleFetchOrders = async () => {
    const orders = await request(fetchOrders());

    return orders;
  };

  return [handleFetchOrders, { loading, error: error?.data?.message }] as const;
};

const useDeleteOrder = () => {
  const [request, { loading, error }] = useAxios<IOrderResource>();

  const handleDeleteOrder = async (id: string) => {
    const order = await request(deleteOrder(id));

    return order;
  };

  return [handleDeleteOrder, { loading, error: error?.data?.message }] as const;
};

const useDownloadOrder = () => {
  const [request, { loading, error }] = useAxios();

  const handleDownloadOrder = async (data: any) => {
    const order = await request(downloadOrder(data));

    return order;
  };

  return [handleDownloadOrder, { loading, error: error?.data?.message }] as const;
};

const useBulkDeleteOrders = () => {
  const [request, { loading, error }] = useAxios<IOrderResource[]>();

  const handleBulkDeleteOrders = async (data: IBulkDeleteRequest) => {
    const orders = await request(deleteOrders(data));

    return orders;
  };

  return [handleBulkDeleteOrders, { loading, error: error?.data?.message }] as const;
};

const useCreateOrder = () => {
  const [request, { loading, error }] = useAxios<IOrderResource>();

  const handleCreateOrder = async (data: IOrderPostRequest) => {
    const order = await request(createOrder(data));
    return order;
  };
  return [handleCreateOrder, { loading, error: error?.data?.message }] as const;
};

export { useFetchOrders, useDeleteOrder, useBulkDeleteOrders, useDownloadOrder, useCreateOrder };
